import {
    CONFIG_LANGUAGE_URL,
    CONFIG_PASSWORD_URL,
    EXTENDED_CACHE_TIME,
    getOAuthConfigURL,
    RECAPTCHA_CONFIG_URL
} from '../../../NonReact/constants/ApiConstants'
import { SelectItem } from '../Components/Selects/Types'
import {
    LanguageConfig,
    PasswordConfig,
    ReCaptchaResponseEnabled,
    ResourceBundle,
    ServerPasswordConfig,
    ServerResourceBundles
} from '../Types/Types'
import { requestGetJSON } from '../../../NonReact/common/API/REST/RESTAPIClient'
import { OAuthConfig, OAuthConfigOptions } from '../Components/OAuthButton/Types/Types'
import { TelSysTypes } from '../../../NonReact/constants/TelephonyServerTypes'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

// Get the password config from the server and map it to the front end structure.
export const getPasswordConfig = (): Promise<PasswordConfig> =>
    requestGetJSON<ServerPasswordConfig>(CONFIG_PASSWORD_URL, { cacheTime: EXTENDED_CACHE_TIME }).then(
        (passwordConfig: JSONResponse<ServerPasswordConfig>): PasswordConfig => ({
            admin: {
                required: !passwordConfig?.UserPasswordEmptyAllowAdmin,
                minLength: passwordConfig?.UserPasswordMinLenAdmin ?? 0,
                entropy: passwordConfig?.UserPasswordMinEntropyAdmin ?? 0
            },
            standard: {
                required: !passwordConfig?.UserPasswordEmptyAllowStd,
                minLength: passwordConfig?.UserPasswordMinLenStd ?? 0,
                entropy: passwordConfig?.UserPasswordMinEntropyStd ?? 0
            }
        })
    )

// Get the language config from the server and map it to the front end structure.
export const getLanguageConfig = (): Promise<LanguageConfig> =>
    requestGetJSON<ServerResourceBundles>(CONFIG_LANGUAGE_URL, { cacheTime: EXTENDED_CACHE_TIME }).then(
        (languageConfig: JSONResponse<ServerResourceBundles>): LanguageConfig =>
            languageConfig?.map(
                (resource: ResourceBundle): SelectItem => ({
                    label: resource.Description,
                    value: resource.Locale
                })
            ) ?? []
    )

/**
 * Fetches the OAuth configuration used to authorise a telephone system of the given type.
 *
 * @param telSysType - Telephone system type being authorised.
 * @param options - Optional settings of the telephone system that shape the configuration, such as whether call
 * recording is enabled (Webex Calling requests access to recordings only when it is).
 * @returns The OAuth configuration, cached per distinct request URL.
 */
export const getOAuthConfig = (telSysType: TelSysTypes, options?: OAuthConfigOptions): Promise<Nullable<OAuthConfig>> =>
    requestGetJSON<OAuthConfig>(getOAuthConfigURL(telSysType, options?.callRecordingEnabled), {
        cacheTime: EXTENDED_CACHE_TIME
    })

export const getReCaptchaConfig = (): Promise<Nullable<ReCaptchaResponseEnabled>> =>
    requestGetJSON<ReCaptchaResponseEnabled>(RECAPTCHA_CONFIG_URL, { cacheTime: EXTENDED_CACHE_TIME })
